/**
 * Method to get the style of the loading outlined
 * used into the used car drawer.
 * @returns {{marginTop: string}} — CSS style.
 */
export const getUsedCarDrawerCustomLoadingOutlinedStyle =
	() => {
		return {
			marginTop: "var(--vh-small)",
		};
	};
